import { render } from "./LangSwitch.vue?vue&type=template&id=5148db57&scoped=true"
import script from "./LangSwitch.vue?vue&type=script&lang=js"
export * from "./LangSwitch.vue?vue&type=script&lang=js"

import "./LangSwitch.vue?vue&type=style&index=0&id=5148db57&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5148db57"]])

export default __exports__